var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"code_msg"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"code_main"},[_c('div',{staticClass:"code_sub"},[_c('div',{attrs:{"id":"captcha"}})])])
}]

export { render, staticRenderFns }